export default __webpack_public_path__ + "static/media/Insomnia IV.d5cb8142.jpg";